module.exports = __webpack_public_path__ + "img/250460827_2025_2-3.0ffb2df1.png";